module.exports = __webpack_public_path__ + "img/aca902d9f1bb4d1993e2fecab33c47e6.112a14d5.png";